import { NgModule } from '@angular/core';
import {
	MSAL_GUARD_CONFIG,
	MSAL_INSTANCE,
	MSAL_INTERCEPTOR_CONFIG,
	MsalBroadcastService,
	MsalGuard,
	MsalInterceptor,
	MsalModule,
	MsalService,
} from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
	MSALGuardConfigFactory,
	MSALInstanceFactory,
	MSALInterceptorConfigFactory,
} from './auth.config';
import { AUTH_CONFIG } from './tokens/auth-config.token';
import { AuthService } from './auth.service';
import { provideMsalIframeSsoInitializer } from './iframe-sso.initializer';

@NgModule({
	imports: [MsalModule],
	providers: [
		provideMsalIframeSsoInitializer(),
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MsalInterceptor,
			multi: true,
		},
		{
			provide: MSAL_INSTANCE,
			useFactory: MSALInstanceFactory,
			deps: [AUTH_CONFIG],
		},
		{
			provide: MSAL_GUARD_CONFIG,
			useFactory: MSALGuardConfigFactory,
			deps: [AUTH_CONFIG],
		},
		{
			provide: MSAL_INTERCEPTOR_CONFIG,
			useFactory: MSALInterceptorConfigFactory,
			deps: [AUTH_CONFIG],
		},
		MsalService,
		MsalGuard,
		MsalBroadcastService,
		AuthService,
	],
	exports: [MsalModule],
})
export class AuthModule {}
